import { ResourcesData } from './types';

export const initialState: ResourcesData = {
  dialog: {
    item: 'user',
    type: undefined,
    values: {},
  },
};
